//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name:'BlogCard',
    props: ['cardContent'],
};
